import React, { useContext, Fragment } from 'react';
import loadable from '@loadable/component';
import Modal from '../Modal';
import { Context } from '../../context/AppContext';
import FullScreenLoader from '../FullScreenLoader';
import { MODALS } from '../../constants';
import WelcomeSuccessModal from '../WelcomeSuccessModal';

const Form = loadable(() => import('./AddABusiness'), {
  fallback: <FullScreenLoader />,
});

const AddABusiness = ({ ...props }) => {
  const modalName = MODALS.ADD_A_BUSINESS;

  const {
    modal: { showModal },
  } = useContext(Context);

  return (
    <Fragment>
      <Modal
        name={modalName}
        onClickOutside={() => showModal(MODALS.MODAL_CONFIRMATION)}
      >
        <Form {...props} />
      </Modal>
      <WelcomeSuccessModal />
    </Fragment>
  );
};

export default AddABusiness;
